export const MODULE_NAME = '@pressreader/popups-core';
